import { Button } from '@mantine/core';
import { PlusIcon } from 'lucide-react';
import styles from './TabView.module.css';

export interface TabInfo {
  id: string;
  label: JSX.Element;
  content: JSX.Element;
}

interface Props {
  tabs: TabInfo[];
  className?: string;
  contentClassName?: string;
  id?: string;
  activeTabId: string | undefined;
  onActiveTabChange: (activeId: string) => void;
  showAddButton?: boolean;
  onAddClick?: () => void;
}

const TabView = ({
  tabs,
  className,
  contentClassName,
  id,
  activeTabId,
  onActiveTabChange,
  showAddButton,
  onAddClick,
}: Props) => {
  return (
    <div className={`${styles.tabViewContainer} ${className ?? ''}`} id={id}>
      <div className={styles.tabViewHeaderScrollWrapper}>
        <div className={styles.tabViewHeader}>
          {tabs.map((tab) => {
            const isActive = activeTabId === tab.id;
            return (
              <div
                key={tab.id}
                data-tab-id={tab.id}
                data-active={isActive ? 'true' : 'false'}
                className={`${styles.tabViewTab} ${
                  isActive ? styles.active : styles.inactive
                }`}
                onClick={() => onActiveTabChange(tab.id)}
              >
                <div className={styles.tabViewTabLabel}>{tab.label}</div>
              </div>
            );
          })}
          {showAddButton === true && (
            <AddButton title='Add' onClick={onAddClick ?? (() => {})} />
          )}
        </div>
      </div>
      <div className={`${styles.tabViewContent} ${contentClassName ?? ''}`}>
        {tabs.find((val) => val.id === activeTabId)?.content ?? ''}
      </div>
    </div>
  );
};

export default TabView;

const AddButton = ({
  title,
  onClick,
}: {
  title: string;
  onClick: () => void;
}) => {
  return (
    <Button
      variant='subtle'
      leftSection={<PlusIcon size={16} />}
      className={styles.tabViewAddButton}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {title}
    </Button>
  );
};
